import { render, staticRenderFns } from "./selectBeVisitDialog.vue?vue&type=template&id=2523d101&scoped=true"
import script from "./selectBeVisitDialog.vue?vue&type=script&lang=js"
export * from "./selectBeVisitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2523d101",
  null
  
)

export default component.exports